document.addEventListener('DOMContentLoaded', function () {
  var product = document.querySelector('.gta-test-new-ux');
  if (!product) return;

  var discountJump = product.querySelector('.gta-price-highlight__team a[href="#gta-discount-tiers"]');
  var discountTiers = product.querySelector('#gta-discount-tiers');
  if (discountJump && discountTiers) {
    discountTiers.setAttribute('tabindex', '-1');
    var revealDiscountTiers = function (updateHash) {
      discountTiers.open = true;
      if (updateHash) window.history.replaceState(null, '', '#gta-discount-tiers');
      discountTiers.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () {
        discountTiers.focus({ preventScroll: true });
      }, 450);
    };
    discountJump.addEventListener('click', function (event) {
      event.preventDefault();
      revealDiscountTiers(true);
    });
    if (window.location.hash === '#gta-discount-tiers') {
      window.setTimeout(function () {
        revealDiscountTiers(false);
      }, 100);
    }
  }

  var customizeButton = product.querySelector('.gta-customize-card__button');
  if (customizeButton) {
    var customizerWarmed = false;
    var warmCustomizer = function () {
      if (customizerWarmed) return;
      customizerWarmed = true;
      var url = new URL(customizeButton.href, window.location.href);
      if (url.origin !== window.location.origin) return;
      var prefetch = document.createElement('link');
      prefetch.rel = 'prefetch';
      prefetch.href = url.href;
      prefetch.as = 'document';
      document.head.appendChild(prefetch);
    };
    customizeButton.addEventListener('pointerenter', warmCustomizer, { once: true });
    customizeButton.addEventListener('focus', warmCustomizer, { once: true });
    customizeButton.addEventListener('touchstart', warmCustomizer, { once: true, passive: true });
  }

  product.querySelectorAll(
    '.product-single__description a[href*="/customise/"],' +
    '.product-single__description a[href*="/customize/"]'
  ).forEach(function (link) {
    if (link.classList.contains('gta-customize-card__button')) return;
    var next = link.nextSibling;
    var previous = link.previousSibling;
    link.remove();
    if (next && next.nodeType === 1 && next.tagName === 'BR') next.remove();
    if (previous && previous.nodeType === 1 && previous.tagName === 'BR') previous.remove();
  });

  var overlay = document.querySelector('[data-gta-qb-overlay]');
  if (!overlay) return;

  function readJson(selector, fallback) {
    try {
      var node = document.querySelector(selector);
      return node ? JSON.parse(node.textContent) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  var variants = readJson('[data-gta-qb-variants]', []);
  var productOptions = readJson('[data-gta-qb-options]', []);
  var config = readJson('[data-gta-qb-config]', {});
  var roster = overlay.querySelector('[data-gta-qb-roster]');
  var form = overlay.querySelector('[data-gta-qb-form]');
  var status = overlay.querySelector('[data-gta-qb-status]');
  var submit = overlay.querySelector('[data-gta-qb-submit]');
  var sizeOptionIndex = productOptions.findIndex(function (option) {
    return /size/i.test(option.name || '');
  });

  function parseColor(value) {
    var parts = String(value || '').split(':');
    return { name: (parts[0] || '').trim(), hex: (parts[1] || '#6b7280').trim() };
  }

  var colors = (config.colors || []).map(parseColor).filter(function (color) { return color.name; });
  var fallbackSizes = (config.sizes || []).map(function (size) { return String(size).trim(); }).filter(Boolean);

  overlay.querySelectorAll('[data-gta-qb-color]').forEach(function (select, index) {
    colors.forEach(function (color) {
      var option = document.createElement('option');
      option.value = color.name;
      option.textContent = color.name;
      option.style.backgroundColor = color.hex;
      select.appendChild(option);
    });
    if (colors.length) select.selectedIndex = Math.min(index, colors.length - 1);
  });

  function variantSize(variant) {
    if (sizeOptionIndex < 0) return '';
    return variant['option' + (sizeOptionIndex + 1)] || '';
  }

  var sizeChoices = [];
  if (sizeOptionIndex >= 0) {
    variants.forEach(function (variant) {
      var name = variantSize(variant);
      if (name && variant.available !== false && !sizeChoices.some(function (choice) { return choice.name === name; })) {
        sizeChoices.push({ name: name, variantId: Number(variant.id) });
      }
    });
  }

  if (!sizeChoices.length) {
    var defaultVariant = variants.find(function (variant) { return variant.available !== false; }) || variants[0];
    fallbackSizes.forEach(function (name) {
      sizeChoices.push({ name: name, variantId: defaultVariant ? Number(defaultVariant.id) : 0 });
    });
  }

  function updateRemoveButtons() {
    var rows = roster.querySelectorAll('[data-gta-qb-row]');
    rows.forEach(function (row) {
      row.querySelector('[data-gta-qb-remove]').hidden = rows.length === 1;
    });
  }

  function addRow() {
    var row = document.createElement('div');
    row.className = 'gta-qb-row';
    row.setAttribute('data-gta-qb-row', '');
    row.innerHTML =
      '<label><span>Size</span><select data-gta-qb-size></select></label>' +
      '<label><span>Quantity</span><input data-gta-qb-quantity type="number" min="1" value="1" inputmode="numeric"></label>' +
      '<button type="button" data-gta-qb-remove aria-label="Remove size">×</button>';

    var select = row.querySelector('[data-gta-qb-size]');
    sizeChoices.forEach(function (choice) {
      var option = document.createElement('option');
      option.value = String(choice.variantId);
      option.dataset.size = choice.name;
      option.textContent = choice.name;
      select.appendChild(option);
    });

    row.querySelector('[data-gta-qb-remove]').addEventListener('click', function () {
      row.remove();
      updateRemoveButtons();
    });
    roster.appendChild(row);
    updateRemoveButtons();
  }

  function openQuickBuy() {
    overlay.hidden = false;
    document.documentElement.classList.add('gta-qb-lock');
    status.textContent = '';
  }

  function closeQuickBuy() {
    overlay.hidden = true;
    document.documentElement.classList.remove('gta-qb-lock');
  }

  product.querySelectorAll('[data-gta-quick-buy-open]').forEach(function (button) {
    button.addEventListener('click', openQuickBuy);
  });
  overlay.querySelectorAll('[data-gta-qb-close]').forEach(function (button) {
    button.addEventListener('click', closeQuickBuy);
  });
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeQuickBuy();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !overlay.hidden) closeQuickBuy();
  });
  overlay.querySelector('[data-gta-qb-add]').addEventListener('click', addRow);

  submit.addEventListener('click', async function () {
    var rows = Array.from(roster.querySelectorAll('[data-gta-qb-row]'));
    if (!rows.length) return;

    var colorProperties = {};
    overlay.querySelectorAll('[data-gta-qb-color]').forEach(function (select) {
      colorProperties[select.dataset.gtaQbColor + ' Color'] = select.value;
    });

    var items = rows.map(function (row) {
      var sizeSelect = row.querySelector('[data-gta-qb-size]');
      var selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      return {
        id: Number(sizeSelect.value),
        quantity: Math.max(1, Math.floor(Number(row.querySelector('[data-gta-qb-quantity]').value) || 1)),
        properties: Object.assign({
          'Order Type': 'Quick Buy',
          'Decoration': 'Blank Jersey',
          'Selected Size': selectedOption ? selectedOption.dataset.size : '',
          '_gta_quick_buy_fee_required': 'true'
        }, colorProperties)
      };
    });

    submit.disabled = true;
    submit.textContent = 'Adding…';
    status.textContent = '';

    try {
      var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Unable to read cart');
      var cart = await cartResponse.json();
      var feeVariantId = Number(config.feeVariantId);
      var feeInCart = cart.items.some(function (item) { return Number(item.variant_id) === feeVariantId; });
      if (!feeInCart) {
        items.push({
          id: feeVariantId,
          quantity: 1,
          properties: {
            'Fee Type': 'Quick Buy Production',
            '_gta_required_quick_buy_fee': 'true'
          }
        });
      }

      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!addResponse.ok) throw new Error(await addResponse.text());
      window.location.href = '/cart';
    } catch (error) {
      status.textContent = 'Could not add the jerseys. Please check your selections and try again.';
      submit.disabled = false;
      submit.textContent = 'Add Jerseys to Cart';
    }
  });

  if (sizeChoices.length) addRow();
});

document.addEventListener('DOMContentLoaded', function () {
  var packageModal = document.querySelector('[data-gta-package]');
  if (!packageModal) return;

  var packageDialog = packageModal.querySelector('.gta-package__dialog');
  var form = packageModal.querySelector('[data-gta-package-form]');
  var openButtons = document.querySelectorAll('[data-gta-package-open]');
  var closeButtons = packageModal.querySelectorAll('[data-gta-package-close]');
  var searchInput = packageModal.querySelector('[data-gta-package-search]');
  var searchResults = packageModal.querySelector('[data-gta-package-results]');
  var selectedWrap = packageModal.querySelector('[data-gta-package-selected]');
  var selectedCount = packageModal.querySelector('[data-gta-package-selected-count]');
  var productsError = packageModal.querySelector('[data-gta-package-products-error]');
  var teamSizeInput = packageModal.querySelector('[data-gta-package-team-size]');
  var baseQuantityInput = packageModal.querySelector('[data-gta-package-base-qty]');
  var neededByInput = packageModal.querySelector('[data-gta-package-needed-by]');
  var summaryPlayers = packageModal.querySelector('[data-gta-package-summary-players]');
  var summaryProducts = packageModal.querySelector('[data-gta-package-summary-products]');
  var summaryPieces = packageModal.querySelector('[data-gta-package-summary-pieces]');
  var itemsField = packageModal.querySelector('[data-gta-package-items]');
  var bodyField = packageModal.querySelector('[data-gta-package-body]');
  var successPanel = packageModal.querySelector('[data-gta-package-success]');
  var submitButton = packageModal.querySelector('[data-gta-package-submit]');
  var currentTitle = packageModal.getAttribute('data-current-product-title') || document.title;
  var currentUrl = packageModal.getAttribute('data-current-product-url') || window.location.href;
  var selectedProducts = [];
  var searchTimer = null;
  var searchController = null;
  var lastFocused = null;
  var previousTeamSize = numberValue(teamSizeInput, 13);

  function numberValue(input, fallback) {
    var value = input ? parseInt(input.value, 10) : fallback;
    return Number.isFinite(value) && value > 0 ? value : fallback;
  }

  function absoluteUrl(url) {
    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return url || '';
    }
  }

  function normalizeProduct(product) {
    return {
      id: String(product.id || product.handle || product.url || product.title),
      title: product.title || 'Gear product',
      url: absoluteUrl(product.url || ('/products/' + product.handle)),
      image: product.image || (product.featured_image && product.featured_image.url) || '',
      price: product.price || product.price_min || '',
      meta: product.type || product.vendor || '',
      quantity: numberValue(teamSizeInput, 13),
      notes: ''
    };
  }

  function isCurrentProduct(product) {
    var currentPath = '';
    var productPath = '';
    try {
      currentPath = new URL(currentUrl, window.location.origin).pathname.replace(/\/$/, '');
      productPath = new URL(product.url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (error) {
      return product.title.toLowerCase() === currentTitle.toLowerCase();
    }
    return currentPath === productPath;
  }

  function hasSelectedProduct(product) {
    return selectedProducts.some(function (item) { return item.id === product.id || item.url === product.url; });
  }

  function setSearchMessage(message) {
    if (!searchResults) return;
    searchResults.replaceChildren();
    var note = document.createElement('p');
    note.className = 'gta-package__search-message';
    note.textContent = message;
    searchResults.appendChild(note);
  }

  function formatPrice(value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'number') return '$' + (value / 100).toFixed(2);
    var text = String(value);
    return text.charAt(0) === '$' ? text : '$' + text;
  }

  function renderSearchResults(products) {
    if (!searchResults) return;
    searchResults.replaceChildren();
    if (!products.length) {
      setSearchMessage('No products found. Try a broader search.');
      return;
    }

    products.forEach(function (rawProduct) {
      var product = normalizeProduct(rawProduct);
      var current = isCurrentProduct(product);
      var alreadyAdded = hasSelectedProduct(product);
      var card = document.createElement('article');
      card.className = 'gta-package__result';

      var image = document.createElement('img');
      image.loading = 'lazy';
      image.alt = '';
      if (product.image) image.src = product.image;

      var copy = document.createElement('div');
      copy.className = 'gta-package__result-copy';
      var title = document.createElement('strong');
      title.textContent = product.title;
      var details = document.createElement('span');
      details.textContent = [product.meta, formatPrice(product.price)].filter(Boolean).join(' · ');
      copy.append(title, details);

      var addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.textContent = current ? 'Included' : (alreadyAdded ? 'Added' : 'Add');
      addButton.disabled = current || alreadyAdded;
      addButton.addEventListener('click', function () {
        if (hasSelectedProduct(product)) return;
        selectedProducts.push(product);
        if (productsError) productsError.hidden = true;
        renderSelectedProducts();
        renderSearchResults(products);
      });

      card.append(image, copy, addButton);
      searchResults.appendChild(card);
    });
  }

  async function searchProducts(query) {
    if (!query || query.trim().length < 2) {
      if (searchResults) searchResults.replaceChildren();
      return;
    }
    if (searchController) searchController.abort();
    searchController = new AbortController();
    setSearchMessage('Searching Gear products...');

    var url = '/search/suggest.json?q=' + encodeURIComponent(query.trim()) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    try {
      var response = await fetch(url, {
        headers: { Accept: 'application/json' },
        signal: searchController.signal
      });
      if (!response.ok) throw new Error('Search request failed');
      var data = await response.json();
      var products = data && data.resources && data.resources.results && data.resources.results.products;
      renderSearchResults(Array.isArray(products) ? products : []);
    } catch (error) {
      if (error.name === 'AbortError') return;
      setSearchMessage('Product search is temporarily unavailable. Please try again.');
    }
  }

  function makeSelectedField(labelText, value, type, onChange) {
    var label = document.createElement('label');
    var labelSpan = document.createElement('span');
    labelSpan.textContent = labelText;
    var input = document.createElement('input');
    input.type = type;
    input.value = value;
    if (type === 'number') {
      input.min = '1';
      input.inputMode = 'numeric';
    } else {
      input.placeholder = 'Sizes, colors, decoration, or other notes';
    }
    input.addEventListener('input', function () { onChange(input.value); });
    label.append(labelSpan, input);
    return label;
  }

  function renderSelectedProducts() {
    if (!selectedWrap) return;
    selectedWrap.replaceChildren();
    if (!selectedProducts.length) {
      var empty = document.createElement('p');
      empty.className = 'gta-package__empty';
      empty.textContent = 'Search above and add at least one coordinated product.';
      selectedWrap.appendChild(empty);
    }

    selectedProducts.forEach(function (product, index) {
      var item = document.createElement('article');
      item.className = 'gta-package__selected-item';

      var image = document.createElement('img');
      image.className = 'gta-package__selected-image';
      image.loading = 'lazy';
      image.alt = '';
      if (product.image) image.src = product.image;

      var copy = document.createElement('div');
      copy.className = 'gta-package__selected-copy';
      var title = document.createElement('strong');
      title.textContent = product.title;
      var link = document.createElement('a');
      link.href = product.url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'View product';
      copy.append(title, link);

      var removeButton = document.createElement('button');
      removeButton.className = 'gta-package__selected-remove';
      removeButton.type = 'button';
      removeButton.textContent = 'Remove';
      removeButton.addEventListener('click', function () {
        selectedProducts.splice(index, 1);
        renderSelectedProducts();
        if (searchInput && searchInput.value.trim().length >= 2) searchProducts(searchInput.value);
      });

      var fields = document.createElement('div');
      fields.className = 'gta-package__selected-fields';
      fields.append(
        makeSelectedField('Quantity', product.quantity, 'number', function (value) {
          product.quantity = Math.max(1, parseInt(value, 10) || 1);
          updateSummary();
          updatePayload();
        }),
        makeSelectedField('Product details', product.notes, 'text', function (value) {
          product.notes = value;
          updatePayload();
        })
      );

      item.append(image, copy, removeButton, fields);
      selectedWrap.appendChild(item);
    });

    if (selectedCount) selectedCount.textContent = selectedProducts.length + (selectedProducts.length === 1 ? ' added' : ' added');
    updateSummary();
    updatePayload();
  }

  function getFieldValue(name) {
    if (!form) return '';
    var field = Array.from(form.querySelectorAll('[name]')).find(function (candidate) {
      return candidate.name === name;
    });
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }

  function productLines() {
    if (!selectedProducts.length) return 'None selected';
    return selectedProducts.map(function (product, index) {
      var line = (index + 1) + '. ' + product.title + ' — Qty ' + product.quantity + '\n   ' + product.url;
      if (product.notes) line += '\n   Details: ' + product.notes;
      return line;
    }).join('\n');
  }

  function updatePayload() {
    if (!form) return;
    var baseQuantity = numberValue(baseQuantityInput, 1);
    var addedProducts = productLines();
    if (itemsField) itemsField.value = addedProducts;
    if (!bodyField) return;

    var lines = [
      'TEAM PACKAGE QUOTE REQUEST',
      '',
      'TEAM',
      'Team / Organization: ' + getFieldValue('contact[Team / Organization]'),
      'Sport: ' + getFieldValue('contact[Sport]'),
      'Expected players: ' + getFieldValue('contact[Expected Players]'),
      'Needed by: ' + getFieldValue('contact[Needed By]'),
      'Shipping ZIP: ' + getFieldValue('contact[Shipping ZIP]'),
      'Budget range: ' + (getFieldValue('contact[Budget Range]') || 'Not specified'),
      '',
      'STARTING JERSEY',
      currentTitle + ' — Qty ' + baseQuantity,
      currentUrl,
      'Details: ' + (getFieldValue('contact[Starting Jersey Details]') || 'Not specified'),
      '',
      'ADDITIONAL PACKAGE PRODUCTS',
      addedProducts,
      '',
      'PACKAGE DETAILS',
      'Team colors: ' + (getFieldValue('contact[Team Colors]') || 'Not specified'),
      'Decoration / Branding: ' + (getFieldValue('contact[Decoration / Branding]') || 'Not specified'),
      'Notes: ' + (getFieldValue('contact[Package Notes]') || 'None'),
      '',
      'CONTACT',
      'Name: ' + getFieldValue('contact[name]'),
      'Email: ' + getFieldValue('contact[email]'),
      'Phone: ' + getFieldValue('contact[phone]'),
      'Preferred contact: ' + getFieldValue('contact[Preferred Contact]'),
      'Best time: ' + (getFieldValue('contact[Best Contact Time]') || 'Not specified'),
      '',
      'Source: ' + window.location.href
    ];
    bodyField.value = lines.join('\n');
  }

  function updateSummary() {
    var players = numberValue(teamSizeInput, 1);
    var baseQuantity = numberValue(baseQuantityInput, 1);
    var additionalPieces = selectedProducts.reduce(function (sum, product) {
      return sum + Math.max(1, parseInt(product.quantity, 10) || 1);
    }, 0);
    if (summaryPlayers) summaryPlayers.textContent = players;
    if (summaryProducts) summaryProducts.textContent = 1 + selectedProducts.length;
    if (summaryPieces) summaryPieces.textContent = baseQuantity + additionalPieces;
  }

  function openPackage() {
    lastFocused = document.activeElement;
    packageModal.hidden = false;
    document.documentElement.classList.add('gta-package-lock');
    window.requestAnimationFrame(function () {
      var firstField = packageModal.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (successPanel) firstField = successPanel.querySelector('button');
      if (firstField) firstField.focus();
    });
  }

  function closePackage() {
    packageModal.hidden = true;
    document.documentElement.classList.remove('gta-package-lock');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  openButtons.forEach(function (button) { button.addEventListener('click', openPackage); });
  closeButtons.forEach(function (button) { button.addEventListener('click', closePackage); });

  document.addEventListener('keydown', function (event) {
    if (packageModal.hidden) return;
    if (event.key === 'Escape') {
      closePackage();
      return;
    }
    if (event.key !== 'Tab' || !packageDialog) return;
    var focusable = Array.from(packageDialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () { searchProducts(searchInput.value); }, 260);
    });
  }

  if (teamSizeInput) {
    teamSizeInput.addEventListener('input', function () {
      var newTeamSize = numberValue(teamSizeInput, 1);
      if (baseQuantityInput && numberValue(baseQuantityInput, 1) === previousTeamSize) baseQuantityInput.value = newTeamSize;
      previousTeamSize = newTeamSize;
      updateSummary();
      updatePayload();
    });
  }

  if (baseQuantityInput) {
    baseQuantityInput.addEventListener('input', function () {
      updateSummary();
      updatePayload();
    });
  }

  if (neededByInput) {
    var today = new Date();
    var localToday = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    neededByInput.min = localToday;
  }

  if (form) {
    form.addEventListener('input', updatePayload);
    form.addEventListener('change', updatePayload);
  }

  if (submitButton && form) {
    submitButton.addEventListener('click', function () {
      updatePayload();
      if (!selectedProducts.length) {
        if (productsError) productsError.hidden = false;
        if (searchInput) searchInput.focus();
        var productStep = packageModal.querySelector('[aria-labelledby^="gta-package-products-"]');
        if (productStep) productStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var requiredFields = Array.from(form.querySelectorAll('[required]'));
      var invalidField = requiredFields.find(function (field) { return !field.checkValidity(); });
      if (invalidField) {
        invalidField.reportValidity();
        invalidField.focus();
        return;
      }

      var postForm = document.createElement('form');
      postForm.method = 'post';
      postForm.action = '/contact#contact_form';
      postForm.hidden = true;

      function appendPostField(name, value) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.value = value;
        postForm.appendChild(hidden);
      }

      appendPostField('form_type', 'contact');
      appendPostField('utf8', '✓');
      appendPostField('return_to', currentUrl + (currentUrl.indexOf('?') === -1 ? '?' : '&') + 'contact_posted=true#gta-ordering-choices');
      Array.from(form.querySelectorAll('[name]')).forEach(function (field) {
        if (field.disabled || !field.name) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        appendPostField(field.name, field.value || '');
      });

      submitButton.disabled = true;
      submitButton.textContent = 'Sending request…';
      document.body.appendChild(postForm);
      postForm.submit();
    });
  }

  updateSummary();
  updatePayload();
  if (successPanel) openPackage();
});
